import React from 'react';
import DatePicker from 'react-datepicker';
import { FieldErrors } from './FieldErrors';
import { utcToZonedTime, zonedTimeToUtc } from 'date-fns-tz';
import 'react-datepicker/dist/react-datepicker.css';
const getTimezone = () => {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
};
export const DateInput = (props) => {
    const timezone = getTimezone();
    return (React.createElement("div", { className: "input-set" },
        React.createElement("label", { htmlFor: props.id },
            props.label,
            props.required ? ' *' : ''),
        React.createElement(DatePicker, { id: props.id, minDate: props.minDate, selected: props.value ? utcToZonedTime(props.value, timezone) : null, onChange: (date) => {
                props.onChange(date ? zonedTimeToUtc(date, timezone).toISOString() : null);
            } }),
        React.createElement(FieldErrors, { errors: props.errors, name: props.name || props.id })));
};
